import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { RequestTypeSelect } from '../request-type-select';

interface StyledRequestTypeSelectProps {
    hasTopMargin: boolean;
}

// eslint-disable-next-line rulesdir/no-styled-export
export const StyledRequestTypeSelect = styled(RequestTypeSelect)`
    margin-top: ${(props: StyledRequestTypeSelectProps) => (props.hasTopMargin ? token('space.400', '32px') : 0)};
`;
